import { IClassificationTrdFileDoc } from "../doc/IClassificationTrdFileDoc";

export function CorrespondenceDigitalSupportFileToTrdFile(
  correspondenceFile: any
): IClassificationTrdFileDoc {
  let latestRecord: any = {};

  if (correspondenceFile && correspondenceFile.trdCode) {
    latestRecord = getLatestRecord(correspondenceFile.trdCode);
  }

  return {
    fileId: undefined,
    fileName: correspondenceFile.fileName,
    url: correspondenceFile.url,
    location: "digitalSupport",
    officeProduction: latestRecord?.officeProduction?.code || "",
    serie: latestRecord?.serie?.serieCode || "",
    subserie: latestRecord?.subserie?.subSerieCode || "",
    typeDocument: latestRecord?.typeDocument?.code || "",
    createdAt: "",
    userId: "",
  };
}

export function CorrespondenceDigitalSupportFileToTrdFileList(
  correspondenceFileList: any[]
): IClassificationTrdFileDoc[] {
  return correspondenceFileList.map((file) =>
    CorrespondenceDigitalSupportFileToTrdFile(file)
  );
}

export function CorrespondenceAppendDocsFileToTrdFile(
  data: any
): IClassificationTrdFileDoc {
  const latestRecord = getLatestRecord(data.trdCode);
  return {
    fileId: undefined,
    fileName: data.filename,
    url: data.url,
    location: "AppendDocs",
    officeProduction: latestRecord?.officeProduction?.code || "",
    serie: latestRecord?.serie?.serieCode || "",
    subserie: latestRecord?.subserie?.subSerieCode || "",
    typeDocument: latestRecord?.typeDocument?.code || "",
    createdAt: "",
    userId: "",
  };
}

export function CorrespondenceappendDocsFileToTrdFileList(
  dataList: any[]
): IClassificationTrdFileDoc[] {
  return dataList.map((file) => CorrespondenceAppendDocsFileToTrdFile(file));
}

export function getLatestRecord(data: any) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return {};
  }

  return data.reduce((prev: any, current: any) => {
    const prevTime = prev.createdAt.seconds + prev.createdAt.nanoseconds / 1e9;
    const currentTime =
      current.createdAt.seconds + current.createdAt.nanoseconds / 1e9;
    return currentTime > prevTime ? current : prev;
  });
}
